import React, { PropsWithChildren, useState } from 'react';
import { Alert, AlertProps, Snackbar, SnackbarProps, SxProps } from '@mui/material';

interface IToastProps {
  text: string;
  variant?: AlertProps['severity'];
  timeout?: number;
  snackbarProps?: SnackbarProps;
  extended?: boolean;
}
interface IToastContextProps {
  showToast: (props: IToastProps) => void;
}
export const ToastContext = React.createContext<IToastContextProps>({
  showToast: () => {}
});

export const ToastProvider = ({ children }: PropsWithChildren) => {
  const [isOpen, setIsOpen] = useState(false);
  const [text, setText] = useState<string | null>(null);
  const [variant, setVariant] = useState<AlertProps['severity']>('error');
  const [timeout, setTimeout] = useState<number | null | undefined>(5000);
  const [extended, setExtended] = useState(false);
  const showToast = ({ text, variant, timeout, extended}: IToastProps) => {
    setIsOpen(true);
    setText(text);
    setVariant(variant);
    if (extended) {
      setExtended(extended);
    }
    if (timeout) {
      setTimeout(timeout);
    }
  };

  //TODO: On multiple entries' implementation may be best to also include an id in the interface
  const onClose = () => {
    setIsOpen(false);
  };
  const extendedSx:SxProps = extended ? {
    width: '1030px',
    marginTop: '5%',
    marginLeft: '10%'
  } : {}
  return (
    <ToastContext.Provider
      value={{
        showToast
      }}
    >
      {children}
      <Snackbar
        id="snackbar-toast"
        open={isOpen}
        autoHideDuration={timeout}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        sx={extendedSx}
      >
        {/*TODO:  Will have to implement method to handle multiple alerts at one time*/}
        <Alert onClose={onClose} severity={variant} sx={{ width: '100%', whiteSpace: 'pre-line' }}>
          {text}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
};
